import PropTypes from 'prop-types';
import React from 'react';
import { components, contentfulViews } from '@glowforge/ui-common';


const { TextSection } = contentfulViews;
const { Button, Markdown } = components;

const ReferralPaypalPage = (props) => {
  let email = '';
  const onPaymentRequest = () => {
    props.requestPaypal(email, props.path);
  };
  const updateEmail = (event) => {
    email = event.target.value;
  };
  return (
    <div className='ReferralPaymentPage contentPage'>
      <TextSection
        {...props.paypalPageContent}
        headerClass='h1'
        className='content' />
      <div className='content'>
        <input
          type='text'
          placeholder='email'
          className='paypalEmailInput'
          onChange={updateEmail} />
        <Button
          type='default'
          size='small'
          className='paypalSubmitButton'
          onClick={onPaymentRequest}>
          {props.pageStrings['credit-removal-button-for-returning-users-rto']}
        </Button>
      </div>
      <div className='content footer-info'>
        <Markdown source={props.createPaypalText.text} />
      </div>
    </div>
  );
};

ReferralPaypalPage.propTypes = {
  requestPaypal: PropTypes.func.isRequired, // eslint-disable-line
  path: PropTypes.string.isRequired, // eslint-disable-line
  paypalPageContent: PropTypes.shape(TextSection.propTypes).isRequired,
  createPaypalText: PropTypes.objectOf(PropTypes.string).isRequired,
  pageStrings: PropTypes.objectOf(PropTypes.string).isRequired,
};

export default ReferralPaypalPage;



// WEBPACK FOOTER //
// ./app/components/support/referral/paypal-page.jsx